import angular from 'angular';

import component from './errorMessage.component';
import constants from '../../constants';
import translationModuleName from '../../translation';
import serviceModuleName from '../../service';

let module = angular.module('recaps.components.errorMessage', [
  constants,
  translationModuleName,
  serviceModuleName,
]);

module.component('errorMessage', component);

export default module;
